export default __webpack_public_path__ + "static/media/sku-comprados.707437a3.svg";